import { atlas } from 'graphql/tags'

export const MANUAL_TRANSACTION_FRAGMENT = atlas`#graphql
  fragment ManualTransaction on ManualPaymentRecord {
    id
    paymentMethod
    paymentDate
    amount
    currency
    recordedBy
    referenceNumber
    notes
    orderId
  }
`

export const MANUAL_TRANSACTIONS_QUERY = atlas`#graphql
  query ManualTransactions($accountId: ID!, $orderIds: [ID!]!) {
    manualPaymentRecords(accountId: $accountId, orderIds: $orderIds) {
      ...ManualTransaction
    }
  }
  ${MANUAL_TRANSACTION_FRAGMENT}
`
